<template>
  <nav-container>
    <template v-slot:headerName>
      <div class="title">
        Users
      </div>
    </template>
    <template v-slot:listItems>
      <ul class="menu">
        <li
          :class="assetClasses('assignment_reportss')"
          class="nav-button assignments"
        >
          <a href="/assignment_reports">Assignments</a>
        </li>
      </ul>
    </template>
  </nav-container>
</template>

<script>
import { mapGetters } from 'vuex'
import NavContainer from '../../shared/NavContainer'
export default {
  components: {
    NavContainer
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ])
  },
  methods: {
    assetClasses (type) {
      // Using slice to singularize the type
      const singularType = type.slice(0, -1)
      const active = this.$router.isRoute(singularType)

      return {
        'nav-item': true,
        'top-active': active
      }
    }
  }
}
</script>
